module.exports = __webpack_public_path__ + "static/placeholder-7c1b3f6ac0f8c67e0da889d23d632695.jpg";